module.exports = __webpack_public_path__ + "static/media/studying.525207dd.svg";